import React from 'react';
import './ProjectSingle.css';

// Import necessary components
import { Lightbox, PageTitle, SidebarHeading, PageSidebar } from '../../../components';
import { projects } from '../../../constants';

// Import icons for visual representation
import { FaArrowRight, FaCircleNotch, FaPrint } from 'react-icons/fa';

// Import useLocation to access route state
import { Link, useLocation } from 'react-router-dom';




const ProjectSingle = () => {

  // Get Project details passed via router state
  const location = useLocation();
  const project = location.state;

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={project.title} page={"Project Single"} />

      <section className='project-single page-single'>

        <div className='project-info page-info'>

          {/* Project Image */}
          <div className='image'>
            <img src={project.image} alt={project.title} />
          </div>

          <div className='content'>

            {/* Sidebar Section */}
            <PageSidebar
              heading={'Position'}
              details={project.details}
            />

            {/* Project Title */}
            <h3 className='main-heading'>{project.title}</h3>

            {/* Project Description */}
            {project.paragraphs.map((paragraph, index) => (
              <p key={index} className={index === 0 ? 'important' : ''}>
                {paragraph}
              </p>
            ))}

            {/* Project Image Gallery */}
            <Lightbox images={project.gallery} />

            {/* Project Procedure Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Project Procedure:</h3>
              <p>We addressed these design challenges with creative, functional solutions tailored to the project.</p>

              {/*Project Procedure Steps */}
              <ul>
                {project.procedure.map((step, index) => {
                  return <li key={index}><FaArrowRight className='icon' />{step}</li>
                })}
              </ul>

            </div>

            {/* Project Results Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Project Results:</h3>
              <p>The project achieved refined spatial design, cohesive aesthetics, and strong client satisfaction.</p>

              {/* Project Results */}
              <ul>
                {project.results.map((result, index) => {
                  return <li key={index}><FaCircleNotch className='icon' />{result}</li>
                })}
              </ul>

            </div>

          </div>

        </div>

        <div className='sidebar service-sidebar'>

          <div className='category sidebar-item'>

            <SidebarHeading title={'all Projects'} />

            <div className='box-container'>
              {projects.map(project => {
                return  (
                /* Link to the individual service page */
                <Link
                  to={{
                    pathname: '/Projects/' + project.title,
                  }}
                  location = {{project}}
                  state= {project}
                  key={project.id}
                  className='item'><span><div className='icon'><FaPrint /></div>{project.title}</span> {/* Service Title */}
                </Link> )
              })}
            </div>

          </div>

        </div>

      </section>

    </> 
  );
}

export default ProjectSingle;